import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach hotelier token from localStorage if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("suitecrowd_hotelier_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Build absolute file URL from a storage image_url like "/api/files/..."
export const fileUrl = (imageUrl) => {
  if (!imageUrl) return "";
  if (imageUrl.startsWith("http")) return imageUrl;
  return `${BACKEND_URL}${imageUrl}`;
};

// Waitlist
export const joinWaitlist = (email, referred_by) =>
  api.post("/waitlist", { email, referred_by }).then((r) => r.data);
export const getWaitlistUser = (code) =>
  api.get(`/waitlist/${code}`).then((r) => r.data);
export const getWaitlistStats = () =>
  api.get("/waitlist/stats/summary").then((r) => r.data);

// Hotels (public)
export const listHotels = () => api.get("/hotels").then((r) => r.data);
export const getHotel = (id) => api.get(`/hotels/${id}`).then((r) => r.data);
export const getHotelUpdates = (id) =>
  api.get(`/hotels/${id}/updates`).then((r) => r.data);

// Admin (Emergent Google Auth)
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authSession = (session_id) =>
  api.post("/auth/session", { session_id }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);

export const adminListWaitlist = () =>
  api.get("/admin/waitlist").then((r) => r.data);
export const adminListAllHotels = () =>
  api.get("/admin/hotels").then((r) => r.data);
export const adminCreateHotel = (payload) =>
  api.post("/admin/hotels", payload).then((r) => r.data);
export const adminUpdateHotel = (id, payload) =>
  api.put(`/admin/hotels/${id}`, payload).then((r) => r.data);
export const adminDeleteHotel = (id) =>
  api.delete(`/admin/hotels/${id}`).then((r) => r.data);
export const adminApproveHotel = (id) =>
  api.post(`/admin/hotels/${id}/approve`).then((r) => r.data);
export const adminRejectHotel = (id) =>
  api.post(`/admin/hotels/${id}/reject`).then((r) => r.data);

// Hotelier auth
export const hotelierRegister = (payload) =>
  api.post("/hotelier/register", payload).then((r) => {
    if (r.data?.token) localStorage.setItem("suitecrowd_hotelier_token", r.data.token);
    return r.data;
  });
export const hotelierLogin = (payload) =>
  api.post("/hotelier/login", payload).then((r) => {
    if (r.data?.token) localStorage.setItem("suitecrowd_hotelier_token", r.data.token);
    return r.data;
  });
export const hotelierLogout = () => {
  localStorage.removeItem("suitecrowd_hotelier_token");
  return api.post("/hotelier/logout").then((r) => r.data);
};
export const hotelierMe = () => api.get("/hotelier/me").then((r) => r.data);

// Hotelier hotel management
export const hotelierGetHotel = () =>
  api.get("/hotelier/hotel").then((r) => r.data);
export const hotelierUpdateHotel = (payload) =>
  api.put("/hotelier/hotel", payload).then((r) => r.data);
export const hotelierUploadMain = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/hotelier/hotel/main-image", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const hotelierGalleryAdd = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/hotelier/hotel/gallery", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const hotelierGalleryRemove = (path) =>
  api.delete("/hotelier/hotel/gallery", { params: { path } }).then((r) => r.data);
export const hotelierSubmit = () =>
  api.post("/hotelier/hotel/submit").then((r) => r.data);

// Timeline updates
export const hotelierUploadUpdateImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/hotelier/uploads", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const hotelierAddUpdate = (caption, image_path) =>
  api
    .post("/hotelier/hotel/updates", { caption, image_path })
    .then((r) => r.data);
export const hotelierListUpdates = () =>
  api.get("/hotelier/hotel/updates").then((r) => r.data);
export const hotelierDeleteUpdate = (id) =>
  api.delete(`/hotelier/hotel/updates/${id}`).then((r) => r.data);

// Payments
export const startCheckout = (hotel_id, email, origin_url) =>
  api.post("/payments/checkout", { hotel_id, email, origin_url }).then((r) => r.data);
export const paymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);
